<template>
    <div>
        <div class="row m-b-md">
            <div class="col-md-3">{{ t_everyday }}:</div>
            <div class="col-md-9">
                <div v-if="project_settings" class="row m-b-xs">
                    <div class="col-md-12" @click.stop.prevent="disableAllProjectOption()">
                        <i :class="[(value.all.active === false && value.all.project === true) ? 'fa-solid' : 'fa-regular', 'fa-circle']" class="fa-lg" aria-hidden="true"></i>&nbsp;{{ t_display_project }}
                    </div>
                </div>
                <div class="row m-b-xs">
                    <div class="col-md-12" @click.stop.prevent="value.all.active = true;value.all.project = false">
                        <i :class="[value.all.active === true ? 'fa-solid' : 'fa-regular', 'fa-circle']" class="fa-lg" aria-hidden="true"></i>&nbsp;{{ t_display_combined }}&nbsp;
                        <label aria-label="timepicker">
                            <vue-timepicker id="all-from" :disabled="!value.all.active"
                                            v-model="value.all.from"
                                            :minute-interval="10"
                                            hide-clear-button
                                            class="control"
                                            auto-scroll
                                            aria-controls="time-picker"
                                            aria-label="timepicker"
                                            manual-input>
                            </vue-timepicker>
                        </label>
                        &nbsp;{{ t_display_on_2 }}&nbsp;
                        <label aria-label="timepicker">
                            <vue-timepicker id="all-to" :disabled="!value.all.active"
                                            v-model="value.all.to"
                                            :minute-interval="10"
                                            hide-clear-button
                                            class="control"
                                            auto-scroll
                                            aria-controls="time-picker"
                                            aria-label="timepicker"
                                            manual-input>
                            </vue-timepicker>
                        </label>
                        &nbsp;{{ t_display_on_3 }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" @click.stop.prevent="disableAllOption()">
                        <i :class="[(!project_settings && value.all.active === false) ||(project_settings && value.all.active === false && value.all.project === false) ? 'fa-solid' : 'fa-regular', 'fa-circle']" class="fa-lg" aria-hidden="true"></i>&nbsp;{{ t_display_separately }}
                    </div>
                </div>
            </div>
        </div>
        <div class="border-bottom"></div>
        <div v-for="(row, weekday) in value.days"
             v-bind:class="[row.errors === true ? 'alert alert-danger m-l-none m-r-none' : '', 'row m-t-md']">
            <div class="col-md-3">{{ weekday_label(weekday) }}:</div>
            <div class="col-md-9">
                <template
                    v-if="value.all.active === true || (value.all.active === false && value.all.project === true)">
                    <span>{{ t_not_configured_separately }}</span>
                </template>
                <template v-else>
                    <div class="row m-b-xs">
                        <div class="col-md-12" @click.stop.prevent="row.active = true">
                            <div v-if="row.errors === true" class="font-bold">{{ t_incorrect_interval }}</div>
                            <i :class="[row.active === true ? 'fa-solid' : 'fa-regular', 'fa-circle']" class="fa-lg" aria-hidden="true"></i>&nbsp;{{ t_display_on_1 }}&nbsp;
                            <vue-timepicker :id="weekday+'-from'" :disabled="!row.active"
                                            v-model="row.from"
                                            :minute-interval="10"
                                            hide-clear-button
                                            class="control"
                                            auto-scroll
                                            manual-input
                                            aria-controls="timepicker"
                                            aria-label="timepicker">
                            </vue-timepicker>
                             {{ t_display_on_2 }}&nbsp;
                            <vue-timepicker :id="weekday+'-to'" :disabled="!row.active"
                                            v-model="row.to"
                                            :minute-interval="10"
                                            hide-clear-button
                                            class="control"
                                            auto-scroll
                                            manual-input
                                            aria-controls="timepicker"
                                            aria-label="timepicker">
                            </vue-timepicker>
                            &nbsp;{{ t_display_on_3 }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12" @click.stop.prevent="disableWeekdayOption(weekday)">
                            <i :class="[row.active === false ? 'fa-solid' : 'fa-regular', 'fa-circle']" class="fa-lg" aria-hidden="true"></i>&nbsp;{{ t_display_off }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    data: function () {
        return {
            t_display_off: Lang.langGet("Display is switched off."),
            t_display_on_1: Lang.langGet("Display is switched on from"),
            t_display_on_2: Lang.langGet("to"),
            t_display_on_3: Lang.langGet("."),
            t_incorrect_interval: Lang.langGet("Incorrect Interval!"),
            t_everyday: Lang.langGet("Every Day"),
            t_display_separately: Lang.langGet("Configure displays separately each day."),
            t_not_configured_separately: Lang.langGet("Day is not configured separately."),
            t_display_combined: Lang.langGet("Every day the display is switched on from"),
            t_display_project: Lang.langGet("The display is configured according to the project settings for each day."),
            element_errors: false,
            project_settings: false
        }
    },
    watch: {
        value: {
            handler: function () {
                this.checkTimes();
                this.$emit('input', this.value);
            },
            deep: true
        }
    },
    methods: {
        weekday_label: function (weekday) {
            return Lang.langGet(weekday[0].toUpperCase() + weekday.slice(1));
        },
        checkTimes: function () {
            this.element_errors = false;

            _.each(this.value.days, (element) => {
                let errors = this.checkFromTo(
                    element.from.HH,
                    element.from.mm,
                    element.to.HH,
                    element.to.mm
                );
                element.errors = errors;

                if (errors === true) {
                    this.element_errors = true;
                }
            });

            if (this.element_errors === false) {
                this.$emit('error', false);
            } else {
                this.$emit('error', true);
            }
        },
        checkFromTo(fromH, fromM, toH, toM) {
            let errors = false,
                iFromH = parseInt(fromH),
                iFromM = parseInt(fromM),
                iToH = parseInt(toH),
                iToM = parseInt(toM);

            if(!(iToH === 0 && iToM === 0)) {
                if (iFromH > iToH) {
                    errors = true;
                }

                if (iFromH === iToH) {
                    if (iFromM >= iToM) {
                        errors = true;
                    }
                }
            }

            return errors;
        },
        disableAllOption: function () {
            this.value.all.active = false;
            this.value.all.project = false;
            this.value.all.from.HH = '07';
            this.value.all.from.mm = '30';
            this.value.all.to.HH = '17';
            this.value.all.to.mm = '30';
        },
        disableAllProjectOption: function () {
            this.value.all.active = false;
            this.value.all.project = true;
            this.value.all.from.HH = '07';
            this.value.all.from.mm = '30';
            this.value.all.to.HH = '17';
            this.value.all.to.mm = '30';
        },
        disableWeekdayOption: function (weekday) {
            this.value.days[weekday].active = false;
            this.value.days[weekday].from.HH = '07';
            this.value.days[weekday].from.mm = '30';
            this.value.days[weekday].to.HH = '17';
            this.value.days[weekday].to.mm = '30';
        }
    },
    mounted() {
        if (typeof this.value.all.project !== 'undefined') {
            this.project_settings = true;
        }
    }
}
</script>
